import type { VirtualMachineLoc } from "@/modules/compute/vmQuery.ts";
import type { DiskWithPrice, DiskWithType } from "@/modules/disks/disksListQuery.ts";
import type { ResourceId } from "@/modules/network/genericResources.ts";
import {
    getResourceId,
    resourceIdToString,
    UNASSIGNED_KEY,
    UNASSIGNED_RESOURCE,
} from "@/modules/network/ipAddress/resourceId.ts";

/** An ID for a resource that can be assigned with an IP address */
export interface DiskResourceId extends ResourceId<"virtual_machine"> {
    $type: "virtual_machine";
    $id: string;
    location: string;
}

export function getResourceStringId(item: VirtualMachineLoc | UNASSIGNED_RESOURCE): string {
    if (item === UNASSIGNED_RESOURCE) {
        return UNASSIGNED_KEY;
    }

    return resourceIdToString(getResourceId(item));
}

export function getAttachedResource(
    disk: DiskWithPrice | DiskWithType,
    items: VirtualMachineLoc[],
): VirtualMachineLoc | null {
    if (disk == null) {
        return null;
    }

    for (const item of items) {
        for (const storage of item.storage) {
            if (storage.uuid === disk.uuid) {
                return item;
            }
        }
    }

    return null;
}

export function getAttachedResourceId(disk: DiskWithPrice): DiskResourceId | UNASSIGNED_RESOURCE {
    if (!disk?.attached_to?.storage?.length) {
        return UNASSIGNED_RESOURCE;
    }

    return {
        $type: "virtual_machine",
        $id: disk.attached_to.uuid,
        location: disk.location,
    };
}

export function getAttachedResourceIsPrimary(disk: DiskWithPrice): boolean {
    if (!disk?.attached_to?.storage?.length) {
        return false;
    }

    return disk.attached_to.storage.find((storage) => storage.uuid === disk.uuid)?.primary ?? false;
}
